<template>
  <div v-if="screenData" class="view tv dark">
    <Screen :data="tv1Screen2">
      <template #header>
        <HeaderBlock>
          <TransportList :current-filter="screenData.currentTransportFilter" />
          <Baseline :data="header.baseline" />
        </HeaderBlock>
      </template>
      <TableBlock :data="tv1Screen2.data" :index="index" />
    </Screen>
    <Screen :data="tv2Screen5">
      <TableBlock :data="tv2Screen5.data" />
    </Screen>
  </div>
</template>

<script>
import Tv from './TvMixin';
import { extendedTimeRangesCaptions, timeRangesCaptions } from '@/pure/ComputedData';

export default {
  mixins: [Tv],

  data() {
    return {
      state: '',
      lastState: '',
      distribution: '',
      index: -1,
      screenData: null,
    };
  },

  computed: {
    header() {
      const { averageTime } = this.screenData;
      return {
        baseline: {
          value: averageTime,
          sub: ' min',
          caption: `${this.$t('averageTimeByCurrentSite')} :`,
        },
      };
    },

    tv1Screen2() {
      const { averageTime, sites } = this.screenData;
      return {
        heading: {
          caption: this.$t('averageAccessTime'),
          icon: 'clock',
          baseline: {
            value: averageTime,
            sub: ' min',
            caption: `${this.$t('CurrentSiteName')} :`,
          },
        },
        data: {
          entries: this.computeAverageTime(sites, averageTime),
        },
      };
    },

    tv2Screen5() {
      const { filteredCollaboratorsCount, collaboratorsByTimeRanges, sites, useExtendedTimeRanges } = this.screenData;
      const value = filteredCollaboratorsCount;
      const supHeaderCaption = useExtendedTimeRanges ? extendedTimeRangesCaptions : timeRangesCaptions;
      const subInfo = {
        supHeaderCaption,
        subHeader: this.$t('CurrentSiteName'),
      };
      const entries = sites.map(site => {
        const result = [];
        if (subInfo.subHeader) {
          result.push({
            type: 'sub-header',
            caption: subInfo.subHeader,
          });
        }
        site.details.collaboratorsByTimeRanges.forEach(item => result.push({ value: item.count }));
        return result;
      });
      const data = this.computeTimeTable(
        collaboratorsByTimeRanges.map(item => item.count),
        entries,
        subInfo,
      );
      return {
        heading: {
          caption: this.$t('collaboratorsByAccessTime'),
          icon: 'clock',
          baseline: {
            value,
            caption: `${this.$t('collaboratorCount')} :`,
          },
        },
        data,
      };
    },
  },

  mounted() {
    const id = this.$route.params.studyId;
    this.$store.dispatch('getStudyResult', { id }).then(() => {
      this.screenData = this.$store.getters.screen();
    });
  },
};
</script>
